import { render, staticRenderFns } from "./DelegationLock.vue?vue&type=template&id=f947ab16&"
import script from "./DelegationLock.vue?vue&type=script&lang=js&"
export * from "./DelegationLock.vue?vue&type=script&lang=js&"
import style0 from "./DelegationLock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports